// ── Dati statici - Pagina Domande Frequenti ────────────────────────────────
// Fonte: SolarMatch_OKFotovoltaico_FAQ.docx (aggiornamento Marzo 2026)
// I testi (domande, risposte, bullets, titoli categorie) sono nelle traduzioni (messages/*.json)
// Questo file mantiene solo dati strutturali: icone e numero di domande per categoria

import { DOMANDE_FREQUENTI_IMAGES as IMG } from './domande-frequenti-images';

// ── Struttura categorie senza testi ────────────────────────────────────────
export interface CategoriaStrutturale {
  icona: string;
  domande: number[]; // array di indici (solo per contare le domande)
}

export const DOMANDE_FAQ_CATEGORIE_STRUTTURALI: CategoriaStrutturale[] = [
  { icona: IMG.faqIcon0, domande: [0, 1, 2, 3, 4] },         // cat0: 5 domande
  { icona: IMG.faqIcon1, domande: [0, 1, 2, 3, 4, 5] },      // cat1: 6 domande
  { icona: IMG.faqIcon2, domande: [0, 1, 2, 3, 4] },         // cat2: 5 domande
  { icona: IMG.faqIcon3, domande: [0, 1, 2, 3, 4] },         // cat3: 5 domande
  { icona: IMG.faqIcon0, domande: [0, 1, 2, 3, 4, 5] },      // cat4: 6 domande
  { icona: IMG.faqIcon1, domande: [0, 1, 2, 3, 4] },         // cat5: 5 domande
  { icona: IMG.faqIcon2, domande: [0, 1, 2, 3, 4] },         // cat6: 5 domande
  { icona: IMG.faqIcon3, domande: [0, 1, 2] },               // cat7: 3 domande
];

// ── Tipologie ──────────────────────────────────────────────────────────────

export interface DomandaFAQ {
  domanda: string;
  risposta: string;
  bullets?: string[];
}

export interface CategoriaFAQ {
  titolo: string;
  icona: string;
  domande: DomandaFAQ[];
}

// ── Categorie FAQ ──────────────────────────────────────────────────────────

export const DOMANDE_FAQ_CATEGORIE: CategoriaFAQ[] = [
  {
    titolo: "OKFotovoltaico: Cos'è e Come Funziona",
    icona: IMG.faqIcon0,
    domande: [
      {
        domanda: "Cos'è OKFotovoltaico?",
        risposta:
          "OKFotovoltaico è la prima piattaforma italiana di consulenza solare basata sull'intelligenza artificiale, gestita da SolarMatch S.r.l. Non siamo un'azienda di installazione: siamo un consulente indipendente che mette in contatto chi vuole installare un impianto fotovoltaico con installatori qualificati e verificati nella propria zona. Il nostro obiettivo è rendere il percorso verso il fotovoltaico semplice, trasparente e senza pressioni commerciali.",
      },
      {
        domanda: 'Qual è la differenza tra OKFotovoltaico e SolarMatch?',
        risposta:
          "OKFotovoltaico è il marchio del servizio; SolarMatch S.r.l. è la società che lo gestisce. In passato il servizio era noto anche come SolarMatch: l'esperienza, la tecnologia e il team sono gli stessi.",
      },
      {
        domanda: 'In che modo OKFotovoltaico è diverso dal chiedere preventivi direttamente agli installatori?',
        risposta:
          "Quando contatti direttamente gli installatori, ricevi offerte non confrontabili e sei esposto a tecniche di vendita aggressive. Con OKFotovoltaico, il processo è capovolto: prima ricevi un'analisi AI imparziale del tuo tetto e del tuo potenziale di risparmio, poi confronti offerte anonime standardizzate su parametri oggettivi (prezzo per kWp, qualità componenti, garanzie, tempi). Solo quando scegli tu, l'installatore riceve i tuoi dati. Sei tu a controllare il processo, non il venditore.",
      },
      {
        domanda: 'Il servizio è davvero gratuito per chi cerca un impianto?',
        risposta:
          "Sì, completamente gratuito. La consulenza con Sofia AI, il report personalizzato, il confronto delle offerte: tutto senza costi per l'utente finale. OKFotovoltaico si sostiene attraverso una commissione pagata dagli installatori solo quando un utente sceglie attivamente di entrare in contatto con loro.",
      },
      {
        domanda: 'Come guadagna OKFotovoltaico?',
        risposta:
          "Gli installatori partner pagano una commissione per ogni lead qualificato che ricevono (modello Pay-Per-Lead). Questo significa che il nostro incentivo è allineato con quello dell'utente: generiamo valore solo quando l'utente trova effettivamente un installatore adatto. Non riceviamo commissioni sulle vendite e non favoriamo nessun installatore rispetto ad altri.",
      },
    ],
  },
  {
    titolo: 'Sofia AI: La Tua Consulente Solare Personale',
    icona: IMG.faqIcon1,
    domande: [
      {
        domanda: "Chi è Sofia AI?",
        risposta:
          "Sofia è la prima consulente solare AI d'Europa. È un'intelligenza artificiale avanzata sviluppata specificamente per il settore fotovoltaico italiano. Puoi parlarle via chat sul sito, al telefono o tramite interfaccia vocale. Sofia conosce la normativa italiana, gli incentivi fiscali aggiornati, le caratteristiche tecniche dei pannelli e le specificità regionali di irraggiamento solare.",
      },
      {
        domanda: "Posso fidarmi dei consigli di un'intelligenza artificiale?",
        risposta:
          "Sofia non \"vende\" nulla: il suo unico obiettivo è fornirti informazioni accurate e imparziali. Utilizza dati tecnici certificati (come quelli del PVGIS, il database europeo di irraggiamento solare) e la normativa italiana aggiornata. A differenza di un consulente commerciale, Sofia non ha interessi economici nel consigliarti un prodotto piuttosto che un altro. Inoltre, ogni report generato include le fonti dei dati utilizzati.",
      },
      {
        domanda: 'Cosa mi chiede Sofia durante la consulenza?',
        risposta: "Sofia ti guida attraverso 5 semplici passaggi:",
        bullets: [
          "La posizione della tua abitazione (per calcolare l'irraggiamento solare)",
          "Il tipo di tetto e la sua orientazione",
          "Il tuo consumo energetico attuale (dalla bolletta)",
          "Le tue preferenze (con o senza batteria di accumulo, budget indicativo)",
          "Eventuali vincoli specifici (condominio, zone vincolate, ecc.)",
        ],
      },
      {
        domanda: 'Quanto dura la consulenza con Sofia?',
        risposta:
          "In media, una conversazione completa con Sofia dura tra i 5 e i 10 minuti. Al termine ricevi immediatamente il tuo report personalizzato con la stima di produzione, risparmio e ritorno dell'investimento.",
      },
      {
        domanda: 'Posso parlare con Sofia al telefono?',
        risposta:
          "Sì. Sofia è disponibile via chat sul sito web e tramite interfaccia vocale telefonica. È la stessa AI: scegli semplicemente il canale che preferisci. La qualità della consulenza è identica.",
      },
      {
        domanda: 'Come funziona la tecnologia AI di OKFotovoltaico?',
        risposta:
          "OKFotovoltaico utilizza un'architettura multiagent con 11 agenti AI specializzati, orchestrati da Sofia. Ogni aspetto del percorso — dalla consulenza personalizzata alla analisi finanziaria, dalla qualificazione alla ricerca del finanziamento ottimale — è gestito da un agente dedicato. Il risultato è una consulenza più precisa, tempi di risposta inferiori a 60 secondi e un matching installatore ottimizzato.",
      },
    ],
  },
  {
    titolo: "Il Percorso: Dalla Consulenza all'Installazione",
    icona: IMG.faqIcon2,
    domande: [
      {
        domanda: 'Come funziona il percorso passo dopo passo?',
        risposta: "Il customer journey OKFotovoltaico si articola in 5 fasi:",
        bullets: [
          "Parla con Sofia – la nostra AI analizza la tua situazione specifica",
          "Ricevi il Report AI – un documento personalizzato con stima di produzione, risparmio e ROI",
          "Confronta le Offerte – ricevi preventivi anonimi da installatori verificati della tua zona",
          "Scegli l'Installatore – solo quando sei pronto, selezioni l'offerta che preferisci",
          "Vieni Connesso – mettiamo in contatto te e l'installatore scelto per procedere",
        ],
      },
      {
        domanda: 'Cosa contiene il Report AI che ricevo?',
        risposta: "Il report include:",
        bullets: [
          "La stima della produzione annua del tuo impianto (in kWh)",
          "Il dimensionamento consigliato (kWp)",
          "La stima del risparmio in bolletta su base annuale",
          "Il calcolo del ritorno dell'investimento (payback period)",
          "Le detrazioni fiscali applicabili alla tua situazione",
          "Un'analisi dell'autoconsumo e dello scambio sul posto",
        ],
      },
      {
        domanda: 'Le offerte che ricevo sono anonime. Perché?',
        risposta:
          "L'anonimato delle offerte è una scelta precisa: elimina il bias del brand e ti permette di confrontare le proposte esclusivamente sui parametri che contano (prezzo, qualità dei componenti, garanzie, tempi di installazione). Solo dopo aver scelto la tua offerta preferita, scopri chi è l'installatore e i tuoi dati vengono condivisi.",
      },
      {
        domanda: "Sono obbligato ad accettare un'offerta?",
        risposta:
          "Assolutamente no. Non c'è nessun obbligo in nessuna fase del processo. Puoi interrompere il percorso in qualsiasi momento senza dover fornire spiegazioni. Il servizio è progettato per darti il controllo, non per metterti sotto pressione.",
      },
      {
        domanda: "Quanto tempo ci vuole dall'inizio alla ricezione delle offerte?",
        risposta:
          "Il report AI viene generato in tempo reale al termine della consulenza con Sofia. Le offerte dagli installatori arrivano tipicamente entro 48 ore, a seconda della disponibilità degli installatori nella tua zona.",
      },
    ],
  },
  {
    titolo: 'Per gli Installatori: il Portale Partner',
    icona: IMG.faqIcon3,
    domande: [
      {
        domanda: 'Come posso diventare un installatore partner OKFotovoltaico?',
        risposta:
          "Per entrare nel network OKFotovoltaico, un installatore deve soddisfare requisiti di qualità:",
        bullets: [
          "Essere un'azienda regolarmente registrata con almeno 2 anni di esperienza nel fotovoltaico",
          "Possedere le abilitazioni professionali richieste dalla normativa italiana",
          "Fornire documentazione su assicurazione RC professionale e referenze verificabili",
        ],
      },
      {
        domanda: 'Quanto costa ricevere un lead?',
        risposta:
          "OKFotovoltaico utilizza un modello Pay-Per-Lead con tre livelli tariffari basati sulla qualificazione del contatto. I costi variano da €69 a €299 per lead, in base al livello di qualificazione e alla dimensione dell'impianto richiesto. Paghi solo per i lead che ricevi, senza costi fissi mensili, abbonamenti o vincoli di durata.",
      },
      {
        domanda: 'Cosa significa "lead qualificato"?',
        risposta:
          "Un lead OKFotovoltaico non è un semplice contatto: è un utente che ha completato l'intero percorso di consulenza AI, ha ricevuto il report personalizzato, ha confrontato le offerte e ha scelto attivamente di entrare in contatto con te. Questo significa che è già informato, ha aspettative realistiche sul costo e il risparmio, ed è pronto per un sopralluogo.",
      },
      {
        domanda: 'Quanti installatori ricevono lo stesso lead?',
        risposta:
          "Ogni lead viene inviato esclusivamente all'installatore scelto dall'utente. Non si tratta di lead condivisi: l'utente confronta le offerte anonime e sceglie un solo installatore con cui procedere. Questo garantisce tassi di conversione significativamente più alti rispetto ai marketplace tradizionali.",
      },
      {
        domanda: 'Come ricevo i lead e come gestisco le mie offerte?',
        risposta: "Tramite il Portale Installatore, un'area riservata dove puoi:",
        bullets: [
          "Configurare il tuo profilo e le zone di copertura",
          "Creare e gestire i template delle offerte",
          "Ricevere notifiche in tempo reale sui nuovi lead",
          "Monitorare le statistiche di conversione e gestire la fatturazione",
        ],
      },
    ],
  },
  {
    titolo: 'Fotovoltaico: Domande Tecniche',
    icona: IMG.faqIcon0,
    domande: [
      {
        domanda: 'Quanto produce un impianto fotovoltaico in Italia?',
        risposta:
          "La produzione dipende dalla zona geografica, dall'orientamento e dall'inclinazione del tetto. Come riferimento, un impianto da 1 kWp con orientamento ottimale produce circa:",
        bullets: [
          "1.150–1.200 kWh/anno al Nord",
          "1.300–1.400 kWh/anno al Centro",
          "1.500–1.600 kWh/anno al Sud e nelle Isole",
        ],
      },
      {
        domanda: 'Di quanto spazio ho bisogno sul tetto?',
        risposta:
          "Con i pannelli moderni ad alta efficienza, servono circa 5–7 mq per ogni kWp installato. Per una famiglia media italiana (consumo di circa 3.000–4.000 kWh/anno), un impianto da 3–4 kWp richiede circa 15–28 mq di superficie sul tetto. Sofia AI verifica la fattibilità in base ai dati della tua abitazione.",
      },
      {
        domanda: 'Quanto dura un impianto fotovoltaico?',
        risposta:
          "I pannelli fotovoltaici moderni hanno una vita utile stimata di 30–40 anni. I produttori garantiscono tipicamente almeno l'80% della potenza nominale dopo 25 anni. L'inverter ha una durata media di 10–15 anni e potrebbe richiedere una sostituzione durante la vita dell'impianto.",
      },
      {
        domanda: "I pannelli funzionano anche d'inverno o con cielo coperto?",
        risposta:
          "Sì. I pannelli producono energia anche con cielo nuvoloso, sebbene con resa ridotta rispetto al pieno sole. In inverno la produzione è inferiore a causa delle giornate più corte, ma viene compensata dalla maggiore produzione estiva. Il report OKFotovoltaico tiene conto della produzione su base annuale, includendo le variazioni stagionali.",
      },
      {
        domanda: 'Conviene aggiungere una batteria di accumulo?',
        risposta:
          "Dipende dal tuo profilo di consumo. Se consumi molta energia nelle ore serali (quando i pannelli non producono), una batteria può aumentare significativamente l'autoconsumo, portandolo dal 30–40% fino al 70–80%. Sofia AI analizza il tuo profilo specifico e ti indica se la batteria rappresenta un investimento conveniente nel tuo caso.",
      },
      {
        domanda: 'Che manutenzione richiede un impianto?',
        risposta:
          "Il fotovoltaico è una tecnologia a bassa manutenzione: non ha parti mobili. È consigliata una pulizia periodica dei pannelli (1–2 volte l'anno) e un controllo tecnico annuale dell'inverter e dei collegamenti. Per impianti sopra gli 11 kWp, la manutenzione periodica è obbligatoria per legge. Il costo medio è di 100–300€/anno per impianti residenziali.",
      },
    ],
  },
  {
    titolo: "Costi, Incentivi e Ritorno dell'Investimento",
    icona: IMG.faqIcon1,
    domande: [
      {
        domanda: 'Quanto costa un impianto fotovoltaico nel 2026?',
        risposta:
          "I costi variano in base alla taglia e alla configurazione. Come riferimento:",
        bullets: [
          "Impianto da 3 kWp (senza accumulo): mediamente 5.500–7.500€",
          "Impianto da 6 kWp con batteria da 10 kWh: mediamente 13.000–16.000€",
        ],
      },
      {
        domanda: 'Quali incentivi fiscali sono disponibili nel 2026?',
        risposta: "I principali incentivi attivi nel 2026 includono:",
        bullets: [
          "Bonus Ristrutturazione: detrazione IRPEF del 50% per la prima casa (36% per seconde case) fino a 96.000€, recuperabile in 10 anni",
          "IVA agevolata al 10% applicata automaticamente in fattura",
          "Conto Termico 3.0: contributo fino al 35% per fotovoltaico con accumulo installato insieme a interventi termici",
          "Comunità Energetiche Rinnovabili (CER): contributo PNRR a fondo perduto del 40% per comuni sotto i 30.000 abitanti",
        ],
      },
      {
        domanda: "In quanto tempo si ripaga l'investimento?",
        risposta:
          "Il tempo di ritorno (payback period) dipende da diversi fattori: dimensione dell'impianto, consumo effettivo, quota di autoconsumo e incentivi utilizzati. In media, con le detrazioni fiscali al 50%, il payback si attesta tra i 4 e i 7 anni. Senza incentivi, tra i 7 e i 12 anni. Considerando che l'impianto dura 30+ anni, il risparmio complessivo sul ciclo di vita è molto significativo.",
      },
      {
        domanda: "È possibile finanziare l'impianto a rate?",
        risposta:
          "Sì. Molti installatori del network OKFotovoltaico offrono soluzioni di finanziamento rateale. Nel tuo percorso su OKFotovoltaico, avrai visibilità sulle opzioni di finanziamento disponibili per ciascuna offerta. In molti casi, la rata mensile del finanziamento è inferiore al risparmio in bolletta, rendendo l'investimento a costo zero fin dal primo mese.",
      },
      {
        domanda: "Cosa succede con l'energia che produco e non consumo?",
        risposta:
          "L'energia in eccesso viene immessa nella rete elettrica. In Italia esistono due meccanismi principali:",
        bullets: [
          "Scambio sul Posto (SSP): ti riconosce un credito economico sull'energia immessa",
          "Ritiro Dedicato: una vendita vera e propria dell'energia al GSE",
        ],
      },
    ],
  },
  {
    titolo: 'Privacy, Sicurezza e Aspetti Legali',
    icona: IMG.faqIcon2,
    domande: [
      {
        domanda: 'I miei dati personali sono al sicuro?',
        risposta:
          "La protezione dei dati è una priorità assoluta per OKFotovoltaico. Operiamo in piena conformità con il GDPR (Regolamento Europeo sulla protezione dei dati). I tuoi dati personali non vengono mai venduti a terzi. Le informazioni vengono condivise con un installatore solo dopo il tuo consenso esplicito e la tua scelta attiva di procedere con quell'offerta.",
      },
      {
        domanda: 'Le offerte sono anonime: come vengono protetti i miei dati durante il confronto?',
        risposta:
          "Durante la fase di confronto offerte, gli installatori non conoscono la tua identità: ricevono solo i dati tecnici necessari per formulare un preventivo (zona geografica, tipo di tetto, consumo energetico). I tuoi dati di contatto vengono condivisi esclusivamente con l'installatore che scegli, e solo dopo la tua conferma esplicita.",
      },
      {
        domanda: 'Posso cancellare i miei dati?',
        risposta:
          "Sì. In qualsiasi momento puoi richiedere la cancellazione completa dei tuoi dati dal nostro sistema, in conformità con il diritto all'oblio previsto dal GDPR. Puoi farlo tramite la tua area utente o contattando il nostro team di supporto.",
      },
      {
        domanda: 'OKFotovoltaico è affiliato a qualche azienda di installazione?',
        risposta:
          "No. OKFotovoltaico è una piattaforma completamente indipendente. Non siamo affiliati, posseduti o controllati da nessuna azienda di installazione fotovoltaica. Questa indipendenza è fondamentale per garantire l'imparzialità delle consulenze AI e l'equità del marketplace.",
      },
      {
        domanda: 'Servono autorizzazioni comunali per installare un impianto fotovoltaico?',
        risposta:
          "Per la maggior parte degli impianti domestici fino a 20 kWp è sufficiente una Comunicazione di Inizio Lavori Asseverata (CILA), un adempimento relativamente semplice che il tuo installatore può gestire. Se l'immobile si trova in zone con vincoli paesaggistici o in centri storici, potrebbe essere necessaria un'autorizzazione paesaggistica. Per impianti oltre i 50 kWp serve un'Autorizzazione Unica regionale. Sofia AI ti segnala eventuali criticità già durante la consulenza.",
      },
    ],
  },
  {
    titolo: 'Supporto e Contatti',
    icona: IMG.faqIcon3,
    domande: [
      {
        domanda: 'Come posso contattare il team OKFotovoltaico?',
        risposta: "Puoi contattarci attraverso diversi canali:",
        bullets: [
          "Chat con Sofia AI sul sito web (disponibile 24/7)",
          "Modulo di contatto nell'area \"Supporto\" del sito",
          "Email al servizio clienti dedicato",
          "Per gli installatori partner: canale di supporto dedicato all'interno del Portale Installatore",
        ],
      },
      {
        domanda: 'Sofia AI è disponibile 24 ore su 24?',
        risposta:
          "Sì. Essendo un'intelligenza artificiale, Sofia è disponibile 24 ore su 24, 7 giorni su 7, senza tempi di attesa. Puoi iniziare la tua consulenza solare in qualsiasi momento, anche di sera o nel weekend.",
      },
      {
        domanda: 'Cosa faccio se ho un problema dopo l\'installazione?',
        risposta:
          "OKFotovoltaico ti accompagna anche nella fase post-installazione. Se riscontri problemi, puoi segnalarli attraverso la piattaforma e ti aiuteremo a metterti in contatto con l'installatore per la risoluzione. Ricorda che ogni installatore del network è tenuto a rispettare standard di garanzia e assistenza verificati in fase di onboarding.",
      },
    ],
  },
];

// ── Compatibilità con la pagina come-funziona (usa ancora DOMANDE_FAQ piatto) ──
export const DOMANDE_FAQ = DOMANDE_FAQ_CATEGORIE.flatMap((cat) =>
  cat.domande.map((d) => ({
    icona: cat.icona,
    domanda: d.domanda,
    risposta: d.risposta,
    rispostaDescrizione: d.risposta,
    rispostaBullets: d.bullets,
  }))
);

// ── Nav Links ──────────────────────────────────────────────────────────────
export const NAV_LINKS = [
  { etichetta: 'Come Funziona', href: '/come-funziona' },
  { etichetta: 'Per Installatori', href: '/per-installatori' },
  { etichetta: 'Chi Siamo', href: '/chi-siamo' },
  { etichetta: 'Domande Frequenti', href: '/domande-frequenti' },
];

// ── Footer Data ────────────────────────────────────────────────────────────
export const FOOTER_DESCRIZIONE =
  'La piattaforma italiana per trovare il miglior impianto fotovoltaico. Consulenza AI gratuita, offerte verificate, nessun impegno.';

export const FOOTER_SOCIAL_ICONS = [IMG.icon10, IMG.icon11, IMG.icon12, IMG.icon13];

export const FOOTER_AZIENDA = ['Chi Siamo', 'Come Funziona', 'Blog', 'Carriere', 'Stampa'];
export const FOOTER_INSTALLATORI = ['Registrati', 'Dashboard', 'Prezzi', 'Supporto', 'Domande Frequenti'];
export const FOOTER_CONTATTI = [
  { icona: IMG.phone, testo: 'hello@solarmatch.it' },
  { icona: IMG.envelopeSimple, testo: 'info@okfotovoltaico.it' },
  { icona: IMG.mapPin, testo: 'Milano, Italia' },
];
export const FOOTER_LEGAL = ['Privacy Policy', 'Termini di Servizio', 'Cookie Policy'];
